import { useEffect, useState } from 'react'

export const useComponentOnScreen = (ref: React.RefObject<HTMLDivElement>): boolean => {
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.intersectionRatio >= 0.3)
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.3
      }
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [ref])
  return isIntersecting
}
